// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "static/" + chunkId + "." + chunkId + "." + {"2530": "e96a97f91d26","3616": "2bd20f1d2224","5461": "4abfb4091f55","6863": "454c9f289029","8357": "dd422574e14d","9597": "3c7698086b5c",}[chunkId] + ".css"
}